import { render, staticRenderFns } from "./Luoghi.vue?vue&type=template&id=1a3a1bb4&"
import script from "./Luoghi.vue?vue&type=script&lang=ts&"
export * from "./Luoghi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports